import React from 'react';

export function SynthflowBackground() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      <div className="synthflow-element synthflow-1 rounded-full" />
      <div className="synthflow-element synthflow-2 rounded-full" />
      <div className="synthflow-element synthflow-3 rounded-full" />
      <div className="synthflow-element synthflow-4 rounded-full" />
    </div>
  );
}